// This file contains the sagas used for async actions in our app.
// Sagas help us gather all our side effects (network requests in this case) in one place

import { fork } from 'redux-saga/effects';
import { loginFlow } from './login';
import { ssoLoginFlow } from './login';
import { validateMfaCodeFlow } from './login';
import { logoutFlow } from './logout';
import { expirationFlow } from './expiration';
import { ResetPasswordFlow } from './resetPassword';
import { getLoginTextFlow } from './getLoginText';
import { forgotPasswordFlow } from './forgotPassword';
import { forgotPasswordConfirmFlow } from './forgotPasswordConfirm';

// The root saga is what we actually send to Redux's middleware.
// In here we fork each saga so that they are all "active" and listening.
// Sagas are fired once at the start of an app and continue running
// in the background, watching actions dispatched to the store.
export default function* root() {
  yield fork(loginFlow);
  yield fork(ssoLoginFlow);
  yield fork(validateMfaCodeFlow);
  yield fork(logoutFlow);
  yield fork(expirationFlow);
  yield fork(ResetPasswordFlow);
  yield fork(getLoginTextFlow);
  yield fork(forgotPasswordFlow);
  yield fork(forgotPasswordConfirmFlow);
}
